import React from 'react';
import { dispatch } from 'nike-re-framejs';

import { DialogBody, DialogTitle, Docked } from '@/ui/dialogs/Dialog';
import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';
import { DialogRowButton, DialogRowIcon, DialogRowText } from '@/ui/dialogs/DialogRow';
import TrashInCircleIcon from '@/icons/TrashInCircleIcon';
import ReclamationIcon from '@/icons/ReclamationIcon';
import EditIcon from '@/icons/EditIcon';

import './BetbookPostMoreOptionsDialog.less';
import { removeComment, setEditedCommentId } from '@/betbook/handlers';

function BetbookCommentsMoreOptionsDialog({ commentId, isMyComment }) {
    return (
        <Docked className="betbook-post-options-dialog">
            <DialogTitle>
                <h2>{i18n('betbook.comments.dialog.title')}</h2>
            </DialogTitle>
            <DialogBody>
                <BetbookCommentsMoreOptionsDialogTooltip commentId={commentId} isMyComment={isMyComment} />
            </DialogBody>
        </Docked>
    );
}

function BetbookCommentsMoreOptionsDialogTooltip({ commentId, isMyComment }) {
    const close = PopupNg.dispatcher.close;
    function reportComment() {
        PopupNg.dispatcher.open('betbook/commentsReport', { commentId: commentId }, 10);
    }

    function editComment() {
        dispatch(setEditedCommentId(commentId));
        close();
    }
    function deleteComment() {
        dispatch(removeComment(commentId));
        close();
    }

    return isMyComment ? (
        <>
            <DialogRowButton onClick={editComment}>
                <DialogRowIcon>
                    <EditIcon />
                </DialogRowIcon>
                <DialogRowText>{i18n('betbook.post.edit')}</DialogRowText>
            </DialogRowButton>
            <DialogRowButton onClick={deleteComment}>
                <DialogRowIcon>
                    <TrashInCircleIcon />
                </DialogRowIcon>
                <DialogRowText>{i18n('betbook.post.delete')}</DialogRowText>
            </DialogRowButton>
        </>
    ) : (
        <DialogRowButton onClick={reportComment}>
            <DialogRowIcon>
                <ReclamationIcon />
            </DialogRowIcon>
            <DialogRowText>{i18n('betbook.post.report')}</DialogRowText>
        </DialogRowButton>
    );
}

export default BetbookCommentsMoreOptionsDialog;
